import { toTitleCase } from "../../../../Utils/stringUtls";
import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import ReviewSummarySectionHeading from "../../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";
import { formatReviewDate } from "../reviewSummaryUtils";

const ProjectDetailsOverview = ({ data, type = "debit" }) => {
  let data1 = data["1_0"];

  // if (type === "credit") {
    data1 = data["0_0"]
  // }
  if (!data1) {
    console.error("data1 is undefined. Available keys in data:", Object.keys(data)); 
    return null;
  }
  
  // Helper function to parse user JSON and format for display
  const parseAndFormatUser = (jsonString) => {
    if (!jsonString) return null;
    try {
      const user = JSON.parse(jsonString);
      // Format: Name (email) - Title
      let formatted = user.name || '';
      if (user.email) {
        formatted += ` (${user.email})`;
      }
      if (user.title) {
        formatted += ` - ${user.title}`;
      }
      return formatted;
    } catch {
      // If it's not JSON, return as is (backward compatibility)
      return jsonString;
    }
  };
  
  const {
    pd_client_name,
    pd_region,
    pd_team_avail,
    pd_pid,
    pd_ticket_num,
    pd_kick_off,
    pd_go_live,
    pd_sales_rep,
    pd_pmo,
    pd_solution_architect,
    pd_po_resource,
    pd_scrum_master,
    pd_account_manager,
    pd_sales_engineer,
  } = data1;
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid" className="review-summary-gap">
        <ReviewSummarySectionHeading title="Project Information" className='review-summary-sub-heading font-bold mt-0'/>
        <ReviewAttribute
          label="Client Name"
          value={pd_client_name ? toTitleCase(pd_client_name) : null}
        />
        <ReviewAttribute
          label="Region"
          value={pd_region ? toTitleCase(pd_region) : null}
        />
        <ReviewAttribute
          label="Project Team Availability"
          value={pd_team_avail ? toTitleCase(pd_team_avail) : null}
        />
        <ReviewAttribute
          label="Project ID"
          value={pd_pid ? pd_pid.toUpperCase() : null}
        />
        <ReviewAttribute
          label="Ticket Number"
          value={pd_ticket_num ? toTitleCase(pd_ticket_num) : null}
        />
        <ReviewAttribute
          label="PO Resource"
          value={parseAndFormatUser(pd_po_resource)}
        />
        <ReviewAttribute
          label="Scrum Master"
          value={parseAndFormatUser(pd_scrum_master)}
        />
        <ReviewAttribute label="Project Kick-off Date" value={formatReviewDate(pd_kick_off)} />
        <ReviewAttribute label="Go-Live Date (Projected)" value={formatReviewDate(pd_go_live)} />

        <ReviewSummarySectionHeading title="i2c Contact Details" className='review-summary-section-heading font-bold mt-0'/>
        <ReviewAttribute
          label="i2c Inc. Sales Rep"
          value={pd_sales_rep ? toTitleCase(pd_sales_rep) : null}
        />
        <ReviewAttribute
          label="i2c Inc. Project Manager"
          value={parseAndFormatUser(pd_pmo)}
        />
        <ReviewAttribute
          label="i2c Inc. Solution Architect"
          value={parseAndFormatUser(pd_solution_architect)}
        />
        <ReviewAttribute
          label="i2c Account Manager"
          value={parseAndFormatUser(pd_account_manager)}
        />
        <ReviewAttribute
          label="i2c Sales Engineer"
          value={parseAndFormatUser(pd_sales_engineer)}
        />
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};

export default ProjectDetailsOverview;
